import { useState } from 'react';
import { useSkuSelector } from '../hooks/useSkuSelector';
import FrameAround from './FrameAround';
import SelectorInternalBox from './SelectorInternalBox';

type SkuSelectorProps = {
	children: React.ReactNode;
	value: string;
};
const CSS_HANDLES = ['skuSelectorItem'];
const SkuSelector = ({ children, value }: SkuSelectorProps) => {
	const [selected, setSelected] = useState(false);
	const { blockClass, imageWidth, imageHeight, withModifiers, prodSum, handles } = useSkuSelector();

	const wm = withModifiers(CSS_HANDLES, selected ? 'selected' : '');
	const renderClass = () => blockClass && `vtex-store-components-3-x-frameAround--${blockClass}`;

	return (
		<div
			style={{ width: imageWidth || 'auto', height: imageHeight || 'auto' }}
			role="button"
			className={`${prodSum ? `${wm} ${handles.skuSelectorItem}` : ''} skuSelectorItem skuSelectorItem--${blockClass}--${value} skuSelectorItemImage vtex-store-components-3-x-skuSelectorItem ${renderClass()} vtex-store-components-3-x-skuSelectorItem--${value} ${
				selected ? 'vtex-store-components-3-x-skuSelectorItem--selected skuSelectorItem--selected' : ''
			} relative di pointer flex items-center outline-0 ma2 vtex-store-components-3-x-skuSelectorItemImage`}
			onClick={() => setSelected(!selected)}
		>
			{selected && <FrameAround selected={selected} />}
			<SelectorInternalBox selected={selected}>{children}</SelectorInternalBox>
		</div>
	);
};

export default SkuSelector;
